import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../login/AuthProvider";
import SwitchBox from "../../components/switchBox";
import { switchHelper, dateHelper, dictFinder } from "../../modules/helpers";
import PageList from "../../components/pageList";
import { news, news_page, art_type, backend } from '../../components/apipath';
import HTMLEditor from "../../components/htmleditor";

let htmlIntroContent = '';
let htmlMainContent = '';
let htmlIntroContent2 = '';
let htmlMainContent2 = '';

function AdmNews() {
  const [newsData, setNewsData] = useState([]);
  const [artTypeList, setArtTypeList] = useState([]);
  const [displayOrder, setDisplayOrder] = useState([]);
  const [rowsCount, setRowsCount] = useState(0);
  const [page, setPage] = useState(1);
  const limit = 50;

  const [editingNews, setEditingNews] = useState(null);
  const [updatedData, setUpdatedData] = useState({});
  const [newData, setNewData] = useState(null);

  const navigate = useNavigate();
  const { token, type } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 🔎 搜尋條件
  const [search, setSearch] = useState({
    keyword: "",
    art_type: "",
    startDate: "",
    endDate: "",
  });

  const PRESET_COVERS = [
    '/uploads/news/ea.png',
    '/uploads/news/cpa.png',
    '/uploads/news/cma.png',
    '/uploads/news/scu.png',
    '/uploads/news/ann.png',
    '/uploads/news/gp.png',
    '/uploads/news/3c.png',
    '/uploads/news/ut.png',
    '/uploads/news/CPE.png',
    '/uploads/news/CIA.png',
    '/uploads/news/CPA, CMA.png',
    '/uploads/news/CPA, CIA.png',
    '/uploads/news/公告（藍）.png',
  ];

const fetchNewsData = async (goPage = 1, rows = 50) => {
  try {
    const params = {
      page: String(goPage - 1),             // 後端 0-based
      rows: String(rows),
      q: (search.keyword || '').trim(),     // 關鍵字
      art_type: search.art_type || '',      // 分類（空字串代表不過濾）
      start: search.startDate || '',        // 起
      end: search.endDate || ''             // 迄
      // 若後端 /search 也支援 status / is_top，再加上：
      // status: search.status ?? '',
      // is_top: search.is_top ?? '',
    };

    console.log('➡️ GET', `${news}search`, 'params=', params);
    const res = await axios.get(`${news}search`, { headers: { token }, params });

    const { data = [], total = 0 } = res.data || {};
    setNewsData(Array.isArray(data) ? data : []);
    setRowsCount(Number(total) || 0);
    setPage(goPage);
  } catch (err) {
    console.error('❌ fetchNewsData error:', err);
    setNewsData([]);
    setRowsCount(0);
  }
};




  const fetchArtTypeList = async () => {
    try {
      const response = await axios.get(`${art_type}`, { headers: { token } });
      setArtTypeList(response.data?.data ?? []);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => { fetchNewsData(1); }, []);        // 初次載入
  useEffect(() => { fetchArtTypeList(); }, []);      // 載入分類

  const startEditing = (newsItem) => {
    htmlIntroContent2 = newsItem.intro;
    htmlMainContent2 = newsItem.content;
    setEditingNews(newsItem);
    setUpdatedData(newsItem);
  };

  // 新增：預設使用內建封面
  const handleAddNew = () => {
    setNewData({
      cate_id: 0,
      art_type: 0,
      art_type_name: '',
      is_top: 0,
      status: 1,
      title: null,
      intro: null,
      content: null,
      cover_1: null,
      cover_file: null,
      coverMode: 'preset',
      coverPreset: PRESET_COVERS[0] || null,
      art_date: null,
      disp_order: null,
      link: null,
    });
  };

  const handleSaveNew = async () => {
    setIsSubmitting(true);
    try {
      let finalCoverPath = null;

      if (newData.coverMode === 'preset') {
        finalCoverPath = newData.coverPreset || null;
      } else if (newData.coverMode === 'upload') {
        if (newData.cover_file) {
          const formData = new FormData();
          formData.append("file", newData.cover_file);
          const uploadRes = await axios.post(`${news}upload`, formData, {
            headers: { "Content-Type": "multipart/form-data", token },
          });
          if (uploadRes.status === 200 && uploadRes.data?.filePath) {
            finalCoverPath = uploadRes.data.filePath;
          } else {
            throw new Error("圖片上傳失敗");
          }
        } else {
          finalCoverPath = null;
        }
      } else {
        finalCoverPath = null;
      }

      const newDatas = {
        ...newData,
        intro: htmlIntroContent,
        content: htmlMainContent,
        cover_1: finalCoverPath,
      };
      delete newDatas.cover_file;
      delete newDatas.coverMode;
      delete newDatas.coverPreset;

      const response = await axios.post(`${news}`, newDatas, { headers: { token } });
      if (response.data.status !== 200) throw new Error(response.data.msg || "新增失敗");

      await fetchNewsData(page);
      htmlIntroContent = '';
      htmlMainContent = '';
      setEditingNews(null);
      setNewData(null);
    } catch (error) {
      console.error("新增失敗:", error);
      alert(error.message || "新增失敗，請稍後再試");
    }
    setIsSubmitting(false);
  };

  const handleNewIntroChange = (name, contents) => { htmlIntroContent = contents; };
  const handleNewContentChange = (name, contents) => { htmlMainContent = contents; };
  const handleUpdateIntroChange = (name, contents) => { htmlIntroContent2 = contents; };
  const handleUpdateContentChange = (name, contents) => { htmlMainContent2 = contents; };

  // Create 處理新行輸入的變化
  const handleNewInputChange = (e) => {
    const { name, value, checked, type } = e.target;
    if (type === 'checkbox'){
      setNewData({ ...newData, [name]: switchHelper(checked) });
    } else if (name === 'art_type') {
      let tmpOrder = 0;
      for (let i in displayOrder) {
        if (parseInt(displayOrder[i].art_type) === parseInt(value)) {
          tmpOrder = parseInt(displayOrder[i].disp_order) + 1;
          break;
        }
      }
      setNewData({
        ...newData,
        [name]: value,
        disp_order: tmpOrder,
        art_type_name: dictFinder(artTypeList, 'type_id', value)?.name
      });
    } else if (name === 'cover_1') {
      if (e.target.files){
        setNewData({ ...newData, [name]: value, cover_file: e.target.files[0] });
      } else {
        setNewData({ ...newData, [name]: value });
      }
    } else {
      setNewData({ ...newData, [name]: value });
    }
  };

  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;
    if (type === 'checkbox'){
      setUpdatedData({ new_id: editingNews.new_id, ...updatedData, [name]: checked ? "1" : "0" });
    } else if (name === 'cover_1') {
      if (e.target.files){
        setUpdatedData({ ...updatedData, [name]: value, cover_file: e.target.files[0] });
      } else {
        setUpdatedData({ ...updatedData, [name]: value });
      }
    } else if (name === 'art_type') {
      setUpdatedData({
        new_id: editingNews.new_id,
        ...updatedData,
        [name]: value,
        art_type_name: dictFinder(artTypeList, 'type_id', value)?.name
      });
    } else {
      setUpdatedData({ new_id: editingNews.new_id, ...updatedData, [name]: value });
    }
  };

  const handleNext = async (obj) => {
    try{
      const order = parseInt(obj.disp_order);
      let objData = { ...obj, disp_order: (order + 1), cover_1: null, cover_file: null };
      const res = await axios.put(`${news}`, objData, { headers: { Authorization: `Bearer ${token}`, token } });
      if (res.data.status !== 200) console.error(res.data.msg);
      else {
        const updatedNewsList = newsData.map(n => n.new_id === obj.new_id ? { ...obj, disp_order: (order + 1) } : n);
        setNewsData(updatedNewsList);
      }
    } catch(err){ console.error(err); }
  };

  const handlePrevious = async (obj) => {
    try{
      const order = parseInt(obj.disp_order);
      let objData = { ...obj, disp_order: Math.max(0, order - 1), cover_1: null, cover_file: null };
      const res = await axios.put(`${news}`, objData, { headers: { Authorization: `Bearer ${token}`, token } });
      if (res.data.status !== 200) console.error(res.data.msg);
      else {
        const updatedNewsList = newsData.map(n => n.new_id === obj.new_id ? { ...obj, disp_order: (order - 1) } : n);
        setNewsData(updatedNewsList);
      }
    } catch(err){ console.error(err); }
  };

  const handleDeleted = async (id) => {
    if (window.confirm("確認刪除 ?")) {
      try{
        const res = await axios.delete(`${news}${id}`, { data: { new_id: id }, headers: { Authorization: `Bearer ${token}`, token } });
        if (res.data.status !== 200) console.error(res.data.msg);
        else fetchNewsData(page);
      } catch(err){ console.error(err); }
    }
  };

  // Update 將資訊依照 new_id 回傳給後端
  const saveChanges = async () => {
    try {
      let uploadedCoverPath = updatedData.cover_1 || null;

      if (updatedData.coverMode === 'preset') {
        uploadedCoverPath = updatedData.coverPreset || null;
      } else if (updatedData.coverMode === 'upload' && updatedData.cover_file) {
        const formData = new FormData();
        formData.append("file", updatedData.cover_file);

        const uploadRes = await axios.post(`${news}upload`, formData, {
          headers: { "Content-Type": "multipart/form-data", token },
        });

        if (uploadRes.status === 200 && uploadRes.data.filePath) {
          uploadedCoverPath = uploadRes.data.filePath;
        } else {
          console.error("圖片上傳錯誤:", uploadRes);
          throw new Error("圖片上傳失敗");
        }
      }

      const updateDatas = {
        ...updatedData,
        new_id: editingNews?.new_id,
        intro: htmlIntroContent2,
        content: htmlMainContent2,
        cover_1: uploadedCoverPath,
      };
      delete updateDatas.cover_file;
      delete updateDatas.coverMode;
      delete updateDatas.coverPreset;

      const response = await axios.put(`${news}`, updateDatas, { headers: { Authorization: `Bearer ${token}`, token } });
      if (response.data.status !== 200) throw new Error(response.data.msg || "更新失敗");

      const updatedNewsList = newsData.map((n) => n.new_id === editingNews.new_id ? updateDatas : n);
      setNewsData(updatedNewsList);

      htmlIntroContent2 = '';
      htmlMainContent2 = '';
      setEditingNews(null);

      console.log("更新成功");
    } catch (error) {
      console.error("更新失敗:", error);
      alert(error.message || "更新失敗，請稍後再試");
    }
  };

  const handleSearchClick = () => {
  setPage(1);
  fetchNewsData(1);
};

  return (
    <>
      <div className="mt100 w-75 mx-auto">
        <div className="text-end mt-2">
          <button className="btn btn-success btn-sm me-2" onClick={handleAddNew}>新增</button>
        </div>

        {/* 🔎 搜尋列 */}
        <div className="card p-3 my-2">
          <div className="row g-2">
            <div className="col-md-3 col-12">
              <div className="input-group input-group-sm">
                <span className="input-group-text">關鍵字</span>
                <input
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="標題／副標／內容"
                  value={search.keyword}
                  onChange={(e) => setSearch(s => ({ ...s, keyword: e.target.value }))}
                  onKeyDown={(e) => e.key === 'Enter' && handleSearchClick()}
                />
              </div>
            </div>

            <div className="col-md-3 col-6">
              <div className="input-group input-group-sm">
                <span className="input-group-text">分類</span>
                <select
                  className="form-select form-select-sm"
                  value={search.art_type}
                  onChange={(e) => setSearch(s => ({ ...s, art_type: e.target.value }))}
                >
                  <option value="">全部</option>
                  {artTypeList?.map((item) => (
                    <option key={item.type_id} value={item.type_id}>{item.name}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-2 col-6">
              <div className="input-group input-group-sm">
                <span className="input-group-text">開始日</span>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={search.startDate}
                  onChange={(e) => setSearch(s => ({ ...s, startDate: e.target.value }))}
                />
              </div>
            </div>

            <div className="col-md-2 col-6">
              <div className="input-group input-group-sm">
                <span className="input-group-text">結束日</span>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={search.endDate}
                  onChange={(e) => setSearch(s => ({ ...s, endDate: e.target.value }))}
                />
              </div>
            </div>

            <div className="col-md-3 col-12 d-flex gap-2">
              <button className="btn btn-primary btn-sm" onClick={handleSearchClick}>搜尋</button>
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={() => {
                  setSearch({ keyword:'', art_type:'', startDate:'', endDate:'' });
                  setPage(1);
                  fetchNewsData(1);
                }}
              >
                清除
              </button>

            </div>
          </div>
        </div>
        {/* 🔎 搜尋列結束 */}

        <div className="mt-2 table-responsive">
          <table className="table table-striped border table-hover">
            <thead>
              <tr>
                <th scope="col">主標</th>
                <th scope="col">副標</th>
                {/* <th scope="col">內容</th> */}
                <th scope="col">圖片</th>
                {/* <th scope="col">日期</th> */}
                <th scope="col">功能</th>
              </tr>
            </thead>
            <tbody>
              {newData && (
                <tr>
                  <td colSpan={4}>
                    <div className="row g-2">
                      <div className="col-xl-3 col-md-4 col-6">
                        <div className="input-group input-group-sm">
                          <span className="input-group-text">分類</span>
                          <select className="form-select form-select-sm" name="art_type" onChange={handleNewInputChange} required>
                            <option key={0} value={''}>請選擇</option>
                            {artTypeList?.map((item) => (
                              <option key={item.type_id} value={item.type_id}>{item.name}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-xl-3 col-md-4 col-6">
                        <div className="input-group input-group-sm">
                          <span className="input-group-text">主標</span>
                          <input className="form-control form-control-sm" onChange={handleNewInputChange} type="text" name="title" />
                        </div>
                      </div>
                      <div className="col-xl-2 col-md-3 col-4">
                        <div className="input-group input-group-sm">
                          <span className="input-group-text">文章日期</span>
                          <input className="form-control form-control-sm" onChange={handleNewInputChange} type="date" name="art_date" defaultValue={dateHelper(Date.now(), 'date')} required />
                        </div>
                      </div>
                      <div className="col-xl-2 col-md-3 col-4">
                        <div className="input-group input-group-sm">
                          <span className="input-group-text">排序</span>
                          <input className="form-control form-control-sm" onChange={handleNewInputChange} type="number" step={1} name="disp_order" defaultValue={newData.disp_order} />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="mb-2 d-flex align-items-center gap-3">
                          <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="new_cover_mode" id="new_cover_mode_preset" value="preset"
                                   checked={newData?.coverMode === 'preset'}
                                   onChange={() => setNewData(d => ({ ...d, coverMode: 'preset', cover_file: null }))} />
                            <label className="form-check-label" htmlFor="new_cover_mode_preset">使用內建封面</label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="new_cover_mode" id="new_cover_mode_upload" value="upload"
                                   checked={newData?.coverMode === 'upload'}
                                   onChange={() => setNewData(d => ({ ...d, coverMode: 'upload', coverPreset: null }))} />
                            <label className="form-check-label" htmlFor="new_cover_mode_upload">自行上傳</label>
                          </div>
                        </div>

                        {newData?.coverMode === 'preset' && (
                          <div className="d-flex flex-wrap gap-3 mb-2">
                            {PRESET_COVERS.map((url) => (
                              <button type="button" key={url}
                                      className={`btn p-0 ${newData?.coverPreset === url ? 'border border-3' : 'border'}`}
                                      onClick={() => setNewData(d => ({ ...d, coverPreset: url }))}
                                      style={{ width: 150, height: 150, overflow: 'hidden', borderRadius: 8 }}
                                      title="選擇此封面">
                                <img src={url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                              </button>
                            ))}
                          </div>
                        )}

                        {newData?.coverMode === 'upload' && (
                          <div className="input-group input-group-sm">
                            <span className="input-group-text">上傳封面</span>
                            <input className="form-control form-control-sm" type="file"
                                   accept="image/png, image/jpeg, image/jpg, image/bmp, image/gif, image/webp"
                                   onChange={(e) => {
                                     const f = e.target.files?.[0] || null;
                                     setNewData(d => ({ ...d, cover_file: f, cover_1: f ? f.name : null }));
                                   }} />
                          </div>
                        )}
                      </div>

                      <div className="col-xl-3 col-md-4 col-6">
                        <div className="input-group input-group-sm">
                          <span className="input-group-text">連結</span>
                          <input className="form-control form-control-sm" onChange={handleNewInputChange} type="text" name="link" />
                        </div>
                      </div>
                      <div className="col-xl-1 col-md-2 col-3">
                        {SwitchBox('is_top', 0, handleNewInputChange, '頂置')}
                      </div>
                      <div className="col-xl-1 col-md-2 col-3">
                        {SwitchBox('status', 1, handleNewInputChange, '啟用')}
                      </div>
                      <div className="col-12">
                        <div className="input-group input-group-sm">
                          <span className="input-group-text">副標</span>
                          {HTMLEditor('', 'intro', handleNewIntroChange)}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="input-group input-group-sm">
                          <span className="input-group-text">內容</span>
                          {HTMLEditor('', 'content', handleNewContentChange)}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <button className="btn btn-primary m-1" onClick={handleSaveNew}>保存</button>
                    <button className="btn btn-secondary m-1" onClick={() => { setNewData(null); htmlIntroContent = ''; htmlMainContent = ''; }}>取消</button>
                  </td>
                </tr>
              )}

              {Array.isArray(newsData) && newsData.length === 0 && (
                <tr>
                  <td colSpan={6} className="text-center text-muted py-4">
                    找不到符合條件的資料
                  </td>
                </tr>
              )}

              {newsData.map((news) => (
                <tr key={news.new_id}>
                  {editingNews && editingNews.new_id === news.new_id ? (
                    <>
                      <td colSpan={4}>
                        <div className="row g-2">
                          <div className="col-xl-3 col-md-4 col-6">
                            <div className="input-group input-group-sm">
                              <span className="input-group-text">分類</span>
                              <select className="form-select form-select-sm" name="art_type" onChange={handleInputChange} defaultValue={news.art_type} required>
                                <option key={0} value={''}>請選擇</option>
                                {artTypeList?.map((item) => (
                                  <option key={item.type_id} value={item.type_id}>{item.name}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-xl-3 col-md-4 col-6">
                            <div className="input-group input-group-sm">
                              <span className="input-group-text">主標</span>
                              <input className="form-control form-control-sm" onChange={handleInputChange} defaultValue={news.title} type="text" name="title" />
                            </div>
                          </div>
                          <div className="col-xl-2 col-md-3 col-4">
                            <div className="input-group input-group-sm">
                              <span className="input-group-text">文章日期</span>
                              <input className="form-control form-control-sm" onChange={handleInputChange} type="date" name="art_date"
                                    defaultValue={dateHelper(news.art_date ?? Date.now(), 'date')} required />
                            </div>
                          </div>
                          <div className="col-xl-2 col-md-3 col-4">
                            <div className="input-group input-group-sm">
                              <span className="input-group-text">排序</span>
                              <input className="form-control form-control-sm" onChange={handleInputChange} type="number" step={1} name="disp_order" defaultValue={news.disp_order} />
                            </div>
                          </div>
                          <div className="col-xl-1 col-md-2 col-3">
                            {SwitchBox('is_top', news.is_top, handleInputChange, '頂置')}
                          </div>
                          <div className="col-xl-1 col-md-2 col-3">
                            {SwitchBox('status', news.status, handleInputChange, '啟用')}
                          </div>
                          <div className="col-xl-3 col-md-4 col-6">
                            <div className="input-group input-group-sm">
                              <span className="input-group-text">連結</span>
                              <input className="form-control form-control-sm" onChange={handleInputChange} type="text" name="link" defaultValue={news.link} />
                            </div>
                          </div>

                          <div className="col-12">
                            <div className="mb-2 d-flex align-items-center gap-3">
                              <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name={`edit_cover_mode_${news.new_id}`}
                                      id={`edit_cover_mode_preset_${news.new_id}`} value="preset"
                                      checked={updatedData?.coverMode === 'preset'}
                                      onChange={() => setUpdatedData(d => ({ ...d, coverMode: 'preset', cover_file: null }))} />
                                <label className="form-check-label" htmlFor={`edit_cover_mode_preset_${news.new_id}`}>使用內建封面</label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name={`edit_cover_mode_${news.new_id}`}
                                      id={`edit_cover_mode_upload_${news.new_id}`} value="upload"
                                      checked={updatedData?.coverMode === 'upload'}
                                      onChange={() => setUpdatedData(d => ({ ...d, coverMode: 'upload', coverPreset: null }))} />
                                <label className="form-check-label" htmlFor={`edit_cover_mode_upload_${news.new_id}`}>自行上傳</label>
                              </div>
                            </div>

                            {updatedData?.coverMode === 'preset' && (
                              <div className="d-flex flex-wrap gap-3 mb-2">
                                {PRESET_COVERS.map((url) => (
                                  <button type="button" key={url}
                                          className={`btn p-0 ${updatedData?.coverPreset === url ? 'border border-3' : 'border'}`}
                                          onClick={() => setUpdatedData(d => ({ ...d, coverPreset: url }))}
                                          style={{ width: 150, height: 150, overflow: 'hidden', borderRadius: 8 }}
                                          title="選擇此封面">
                                    <img src={url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                  </button>
                                ))}
                              </div>
                            )}

                            {updatedData?.coverMode === 'upload' && (
                              <div className="input-group input-group-sm mb-2">
                                <span className="input-group-text">上傳封面</span>
                                <input className="form-control form-control-sm" type="file"
                                      accept="image/png, image/jpeg, image/jpg, image/bmp, image/gif, image/webp"
                                      onChange={(e) => {
                                        const f = e.target.files?.[0] || null;
                                        setUpdatedData(d => ({ ...d, cover_file: f }));
                                      }} />
                                <small className="input-group-text text-muted">
                                  {news.cover_1 ? "再次選擇檔案" : "請選擇檔案"}
                                </small>
                              </div>
                            )}

                            <div className="mb-2">
                              <img src={updatedData?.coverPreset || updatedData?.cover_1 || news.cover_1} alt="" style={{ width: 280, maxWidth: '100%', borderRadius: 8 }} />
                            </div>
                          </div>

                          <div className="col-12 w-100">
                            <div className="input-group input-group-sm">
                              <span className="input-group-text">副標</span>
                              {HTMLEditor(news.intro, 'intro', handleUpdateIntroChange)}
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="input-group input-group-sm w-100">
                              <span className="input-group-text">內容</span>
                              {HTMLEditor(news.content, 'content', handleUpdateContentChange)}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <button className="btn btn-primary btn-sm m-1" onClick={saveChanges}>保存</button>
                        <button className="btn btn-secondary btn-sm m-1" onClick={() => { setEditingNews(null); htmlIntroContent2 = ''; htmlMainContent2 = ''; }}>取消</button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="col-2">
                        <div className="mb-2">
                          {news.is_top ? (<i className="fa-solid fa-thumbtack fa-fw me-1 text-success"></i>) : ''}
                          {!news.status ? (<i className="fa-regular fa-eye-slash fa-fw me-1 text-danger"></i>) : <i className="fa-regular fa-eye me-1 text-warning"></i>}
                          <strong>{news.art_type_name}</strong>
                        </div>
                        {news.title}
                      </td>
                      <td className="col-2">
                        <div className="table-responsive" style={{ maxWidth: "400px", maxHeight: "300px" }}>
                          <table className="table table-striped">
                            <tbody>
                              <tr>
                                <td><div dangerouslySetInnerHTML={{ __html: news.intro }}></div></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                      {/* <td className="col-4">
                        <div className="table-responsive" style={{ maxWidth: "400px", maxHeight: "300px" }}>
                          <table className="table table-striped">
                            <tbody>
                              <tr>
                                <td><div dangerouslySetInnerHTML={{ __html: news.content }}></div></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td> */}
                      <td className="col-2">
                        <div>
                          <img src={`${news.cover_1}`} alt="" style={{ width: "50%" }} />
                          {/* ${backend}往前放 */}
                        </div>
                      </td>
                      {/* <td className="col-2">
                        <span className="text-nowrap">{dateHelper(news.art_date, 'date')}</span>
                      </td> */}
                      <td className="col-2">
                        <button className="btn btn-sm btn-success m-1" onClick={() => handlePrevious(news)}>上移</button>
                        <button className="btn btn-sm btn-warning m-1" onClick={() => handleNext(news)}>下移</button>
                        <button className="btn btn-sm btn-primary m-1" onClick={() => startEditing(news)}>編輯</button>
                        {type === 'admin' ? (
                          <button className="btn btn-sm btn-danger m-1" onClick={() => handleDeleted(news.new_id)}>刪除</button>
                        ) : null}
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
<div className="m-2 p-2">
  { PageList(rowsCount, (goToPage) => { setPage(goToPage); fetchNewsData(goToPage); }) }
</div>

    </>
  );
}
export default AdmNews;
